var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-select" },
    [
      _c(
        "div",
        { staticClass: "edit-table" },
        [
          _c("div", { staticClass: "title_2" }, [_vm._v("费用清单")]),
          !_vm.disabled
            ? _c("vxe-toolbar", {
                staticStyle: { "margin-left": "125px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "buttons",
                      fn: function () {
                        return [
                          _c(
                            "vxe-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openModal()
                                },
                              },
                            },
                            [_vm._v("添加费用清单")]
                          ),
                          _c(
                            "vxe-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.clearFn()
                                },
                              },
                            },
                            [_vm._v("清空")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2840559159
                ),
              })
            : _vm._e(),
          _c(
            "vxe-table",
            {
              staticStyle: { "margin-left": "125px" },
              attrs: { data: _vm.listOne },
            },
            [
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "createDateAll",
                  title: "创建时间",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "channelFeeName",
                  title: "渠道费用名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "channelCash",
                  title: "金额",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productName",
                  title: "商品名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productCode",
                  title: "商品编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "orderCode",
                  title: "需货单号",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "channelNum",
                  title: "数量",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "effectiveDate",
                  title: "生效时间",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "feeType",
                  title: "费用类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.feeType === "month"
                          ? _c("span", [_vm._v("月度")])
                          : row.feeType === "season"
                          ? _c("span", [_vm._v("季度")])
                          : row.feeType === "year"
                          ? _c("span", [_vm._v("年度")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "channelFeeCode",
                  title: "渠道费用编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "isSupplyBill",
                  title: "是否开票",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isSupplyBill === "Y"
                          ? _c("span", [_vm._v("是")])
                          : _c("span", [_vm._v("否")]),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.disabled
                ? _c("vxe-column", {
                    attrs: { title: "操作", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row, rowIndex }) {
                            return [
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "red",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deletRow(row, rowIndex)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3921525946
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "title_2" }, [_vm._v("货补池信息")]),
          _c(
            "vxe-table",
            {
              staticStyle: { "margin-left": "125px" },
              attrs: { data: _vm.listTwo },
            },
            [
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "channelFeeCode",
                  title: "渠道费用编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "feeType",
                  title: "费用类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.feeType === "month"
                          ? _c("span", [_vm._v("月度")])
                          : row.feeType === "season"
                          ? _c("span", [_vm._v("季度")])
                          : row.feeType === "year"
                          ? _c("span", [_vm._v("年度")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "orderCode",
                  title: "需货单号",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "fiscalYear",
                  title: "财年",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "custName",
                  title: "经销商名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "200",
                  field: "companyName",
                  title: "公司主体",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, rowIndex }) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "公司主体",
                              disabled: _vm.disabled,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.companyChange($event, rowIndex)
                              },
                            },
                            model: {
                              value: row.companyName,
                              callback: function ($$v) {
                                _vm.$set(row, "companyName", $$v)
                              },
                              expression: "row.companyName",
                            },
                          },
                          _vm._l(_vm.companyList, function (item) {
                            return _c("el-option", {
                              key: item.companyCode,
                              attrs: {
                                label: item.companyName,
                                value: item.companyCode,
                              },
                            })
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productName",
                  title: "商品名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "transformCash",
                  title: "划转金额",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "unitPrice",
                  title: "产品单价",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "transformNum",
                  title: "划转数量",
                },
              }),
              _c(
                "vxe-table-column",
                { attrs: { "min-width": "100", field: "unit", title: "单位" } },
                [_vm._v("瓶")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }